import type { GetMarketRow } from '@morfi/backend-sdk-v2/client';
import { estimatePrizePoolPayouts } from '@morfi/market-math';
import type { PrizePoolPayoutEstimateView } from '@/components/chart/prize-pool/prize-pool-context';
import type { PrizePoolHolding } from '@/hooks/positions/user-portfolio/use-prize-pool-holdings';

export function buildPayoutModel(args: {
  readonly market:
    | (Pick<GetMarketRow, 'prizePool'> & {
        readonly outcomes: readonly Pick<
          GetMarketRow['outcomes'][number],
          'outcomeIndex' | 'label' | 'latestPoolQuoteD6' | 'virtualQuoteD6' | 'claimRightsSupplyD6'
        >[];
      })
    | undefined;
  readonly positionRows: readonly PrizePoolHolding[];
  readonly isAuthenticated: boolean;
  readonly positionScopeLoading: boolean;
  readonly marketIsPending: boolean;
  readonly positionsPending: boolean;
}): {
  readonly estimates: readonly PrizePoolPayoutEstimateView[] | null;
  readonly pending: boolean;
} {
  const marketOutcomes = args.market?.outcomes ?? [];
  const result = estimatePrizePoolPayouts({
    prizePoolD6: args.market?.prizePool,
    outcomes: marketOutcomes.map((outcome) => ({
      outcomeIndex: outcome.outcomeIndex,
      label: outcome.label,
      latestPoolQuoteD6: outcome.latestPoolQuoteD6,
      virtualQuoteD6: outcome.virtualQuoteD6,
      claimRightsSupplyD6: outcome.claimRightsSupplyD6,
    })),
    holdings: args.positionRows.map((position) => ({
      outcomeIndex: position.outcomeIndex,
      claimRightsBalanceD6: position.claimRightsBalanceD6,
    })),
  });
  return {
    estimates: result.available
      ? result.value.map((estimate) => ({
          outcomeIndex: estimate.outcomeIndex,
          label: estimate.label,
          claimantShareMicroPercent: estimate.claimantShareMicroPercent,
          estimatedPayoutD6: estimate.estimatedPayoutD6.toString(),
        }))
      : null,
    pending:
      args.isAuthenticated &&
      ((args.marketIsPending && args.market === undefined) ||
        (args.positionRows.length === 0 && (args.positionScopeLoading || args.positionsPending))),
  };
}
